import { configureStore } from '@reduxjs/toolkit';
// import rootReducer from './rootReducer';
import authReducer from './slice/authSlice';
import userReducer from "./slice/userSlice";
import propertyReducer from "./slice/propertiesSlice";
import inquiryReducer from "./slice/inquirySlice";
import bankReducer from "./slice/bankSlice";
import allPropertiesReducer from './slice/allPropertiesSlice';
import fieldsReducer from './slice/fieldsSlice';
import allUsersReducer from './slice/allUsersSlice'
import bannerReducer from './slice/bannerSlice'
import mapReducer from './slice/mapSlice'
import jantriReducer from './slice/jantriSlice'
import settingReducer from './slice/settingSlice'
import companyReducer from './slice/companySlice'
import introductionScreenReducer from './slice/introductionScreenSlice'
import subscriptionReducer from './slice/subscriptionSlice'
import marketplaceReducer from './slice/marketplaceSlice'
import locationReducer from './slice/locationSlice'
import postCommentReducer from './slice/postCommentSlice'
import professionReducer from './slice/professionSlice'
import companyCategoryReducer from './slice/companyCategorySlice'
import categoryReducer from './slice/categorySlice'
import adConfigReducer from './slice/adConfigSlice'
import adminRoleReducer from './slice/adminRoleSlice'
import adminUserReducer from './slice/adminUserSlice'
import brokerClientsReducer from './slice/brokerClientsSlice'
import profileSuggestionCardReducer from './slice/profileSuggestionCardSlice'
import gisTrialReducer from './slice/gisTrialSlice'

const store = configureStore({
  reducer: {
    auth: authReducer,
    property: propertyReducer,
    inquiry: inquiryReducer,
    user: userReducer,
    allUsers: allUsersReducer,
    bank: bankReducer,
    allProperties: allPropertiesReducer,
    fields: fieldsReducer,
    banners: bannerReducer,
    maps: mapReducer,
    jantri: jantriReducer,
    settings: settingReducer,
    company: companyReducer,
    introductionScreens: introductionScreenReducer,
    subscription: subscriptionReducer,
    marketplace: marketplaceReducer,
    location: locationReducer,
    postComments: postCommentReducer,
    profession: professionReducer,
    companyCategory: companyCategoryReducer,
    category: categoryReducer,
    adConfig: adConfigReducer,
    adminRoles: adminRoleReducer,
    adminUsers: adminUserReducer,
    brokerClients: brokerClientsReducer,
    profileSuggestionCards: profileSuggestionCardReducer,
    gisTrial: gisTrialReducer,
  },
  // auth: authReducer,
  // reducer: rootReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),

  //   devTools: process.env.NODE_ENV !== 'production',  // Enables Redux DevTools in development
  //   // You can also add middleware here if needed
});

export default store;